import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { DeleteFormCommandHandler } from './delete-form-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { CreateCommandHandler } from './create-command-handler.service';

@Injectable()
export class FormCommandHandlerResolver extends CommandHandlerResolver {
  constructor(createHandler: CreateCommandHandler, deleteHandler: DeleteFormCommandHandler) {
    super();
    this.addHandler(standardCommand.create, createHandler);
    this.addHandler(standardCommand.delete, deleteHandler);
  }
}
